import type { TCatalogClass } from '@schemas'

export type CatalogChoice = TCatalogClass & { modelId: string; catalogSubtypeId?: string }
export const catalogChoiceKey = (modelId: string, subtypeId?: string | null) =>
  subtypeId ? `${modelId}::${subtypeId}` : modelId

/** One selectable row per valid model/subtype combination. */
export function catalogChoices(models: TCatalogClass[]): CatalogChoice[] {
  return models
    .filter(model => !model.retired)
    .flatMap(model => {
      const subtypes = model.subtypes ?? []
      if (!model.requiresSubtype && !subtypes.length) return [{ ...model, modelId: model.id }]
      return subtypes
        .filter(subtype => !subtype.retired)
        .map(subtype => ({
          ...model,
          modelId: model.id,
          id: catalogChoiceKey(model.id, subtype.id),
          catalogSubtypeId: subtype.id,
          name: `${model.name} — ${subtype.name}`,
        }))
    })
}
